import { Flex } from '@vimeo/bokeh';
import { createInteractionDomName } from '@vimeo/cloud-live/libs/shared/utils/dom/identifying';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { useLiveGlobals } from '@vimeo/live-core/components/providers/globals';
import { ESidebarAttach } from '@vimeo/live-core/components/sidebar';
import { useIsPortraitScreenOrientation } from '@vimeo/live-core/hooks/dom/useIsPortraitScreenOrientation';
import { IInteractionStoreInitialState } from '@vimeo/live-core/types/store';

import { PAGE_WRAPPER_STYLE } from '../styles';
import { InteractionSidebar } from './InteractionSidebar';

/**
 * Automatic layout with panel to allow users select preferred section.
 */
export function InteractionAutoLayout({
  id = createInteractionDomName('widget-auto'),
}: IBaseDomElementProps) {
  const isPortrait: boolean = useIsPortraitScreenOrientation();

  const {
    initialState: { interaction },
  } = useLiveGlobals<IInteractionStoreInitialState>();
  const attach: ESidebarAttach = interaction?.toolbar?.attachPosition || ESidebarAttach.RIGHT;

  return (
    <Flex id={id} sx={PAGE_WRAPPER_STYLE}>
      <Flex
        id={createInteractionDomName(id, 'main')}
        position={'relative'}
        height={'100%'}
        width={'100%'}
        flexGrow={1}
        overflow={'hidden'}
        background={'surface'} //core.color.surface(800)
        maxWidth={'100%'}
        flexDirection={
          attach === ESidebarAttach.TOP || attach === ESidebarAttach.BOTTOM || isPortrait
            ? 'column'
            : 'row'
        }
        justifyContent={
          attach === ESidebarAttach.TOP || (attach === ESidebarAttach.LEFT && !isPortrait)
            ? 'flex-start'
            : 'flex-end'
        }
      >
        <InteractionSidebar
          id={createInteractionDomName(id, 'sidebar')}
          attach={attach}
          isPortrait={isPortrait}
          isStandalone={interaction?.isStandalone}
          isFullscreen={interaction?.toolbar?.panelIsFluid}
          maxSize={interaction?.toolbar?.panelMaxSize}
          onOpen={interaction?.toolbar?.panelOnOpen}
          onClose={interaction?.toolbar?.panelOnClose}
          onToggleExtend={interaction?.toolbar?.panelOnToggleExtend}
        />
      </Flex>
    </Flex>
  );
}
